import React, { useState } from "react";

import iconCheck from "./chrome/icon-node-completed.svg";

/**
 * Escolha do explorador. Tela cheia, não overlay compacto: é um momento de
 * imersão, o aluno está decidindo quem ele é na jornada.
 *
 * @param {Array}    avatares    [{ id, nome, asset }]
 * @param {string}   avatarId    seleção já feita, se houver
 * @param {Function} onConcluir  recebe o id escolhido
 */
function SelecaoAvatar({ avatares = [], avatarId = null, onConcluir }) {
  const [escolhido, setEscolhido] = useState(avatarId);

  return (
    <div className="avatar-select">
      <header className="avatar-select__cabecalho">
        <h1>Escolha seu explorador</h1>
        <p>Esse será o seu personagem em toda a jornada de aprendizado.</p>
      </header>

      <div className="avatar-select__grade">
        {avatares.map(avatar => (
          <button
            key={avatar.id}
            type="button"
            className={`avatar-select__card${
              escolhido === avatar.id ? " avatar-select__card--selecionado" : ""
            }`}
            data-avatar={avatar.id}
            aria-pressed={escolhido === avatar.id}
            onClick={() => setEscolhido(avatar.id)}
          >
            <span className="avatar-select__fundo" aria-hidden="true" />
            <img
              className="avatar-select__figura"
              src={avatar.asset}
              alt={avatar.nome}
            />
            <span className="avatar-select__nome">{avatar.nome}</span>
            <img
              className="avatar-select__check"
              src={iconCheck}
              alt=""
              aria-hidden="true"
            />
          </button>
        ))}
      </div>

      <button
        type="button"
        className="tl-btn"
        disabled={!escolhido}
        onClick={() => onConcluir(escolhido)}
      >
        Continuar
      </button>
    </div>
  );
}

export default SelecaoAvatar;
